<template>
    <on-click-outside :do="close">
        <div class="">
            <div ref="button"></div>
            <div class="bg-white rounded-lg shadow-md flex flex-row absolute p-4 mt-6 -ml-20" ref="confirmdelete" v-if="showDeleteConfirm">
                <div class="button-class bg-red py-1 px-5 cursor-pointer" @click.prevent="deletNewPlace"><p>Удалить</p></div>
                <div class="button-class bg-grey-darkest py-1 px-5 cursor-pointer" @click.prevent="$emit('close')"><p>Нет</p></div>
            </div>
        </div>
    </on-click-outside>
</template>

<script>
import Popper from 'popper.js';
import OnClickOutside from '../../OnClickOutside';

export default {
  props: ['showDeleteConfirm'],
  name: 'confirm-delete',
  components: { OnClickOutside },

  data() {
    return {
      confirnHide: this.showDeleteConfirm,
    };
  },
  beforeDestroy() {
    if (this.popper !== undefined) {
      this.popper.destroy();
    }
  },
  methods: {
    switchPopper() {
      this.confirnHide = !this.confirnHide;
      if (this.confirnHide) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.button, this.$refs.confirmdelete, {
          placement: 'bottom',
          positionFixed: false,
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
    deletNewPlace() {
      this.$emit('deletePlace');
      this.$emit('close');
    },
    close() {
      if (!this.confirnHide) {
        return;
      }
      this.confirnHide = false;
    },
  },
};
</script>

<style scoped lang="less">
    .button-class{
        color: white;
        border-radius: 1rem;
    }
</style>
